import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Pagination from "../../../Components/Common/Pagination";
import {
  getContactMessages,
  deleteContactMessage,
} from "../../../slices/10-contactUs/thunk";

const ContactUsTable = () => {
  const dispatch = useDispatch();

  const { messages, loading, totalPages } = useSelector(
    (state) => state.contact,
  );

  const [page, setPage] = useState(1);
  const limit = 10;

  const [viewModal, setViewModal] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);

  useEffect(() => {
    dispatch(getContactMessages({ page, limit }));
  }, [dispatch, page]);

  const handleView = (data) => {
    setSelectedMessage(data);
    setViewModal(true);
  };

  const handleDelete = (id) => {
    if (window.confirm("هل أنت متأكد من حذف الرسالة؟")) {
      dispatch(deleteContactMessage(id));
    }
  };

  document.title = "رسائل تواصل معنا";
  // console.log(totalPages);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="رسائل تواصل معنا" pageTitle="لوحة التحكم" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">جميع الرسائل</h4>
                </CardHeader>

                <CardBody>
                  <div className="table-responsive">
                    <table
                      className="table align-middle table-nowrap"
                      id="customerTable"
                    >
                      {" "}
                      <thead className="table-light text-center">
                        <tr>
                          <th>الاسم</th>
                          <th>البريد الإلكتروني</th>
                          <th>رقم الهاتف</th>
                          <th>تاريخ الإرسال</th>
                          <th>تنفيذ</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all  text-center">
                        {messages && messages?.length > 0 ? (
                          messages?.map((msg) => (
                            <tr key={msg.id}>
                              <td>
                                {msg.first_name} {msg.last_name}
                              </td>
                              <td>{msg.email}</td>
                              <td>{msg.phone}</td>
                              <td>
                                {new Date(msg.createdAt).toLocaleString()}
                              </td>
                              <td>
                                <div className="d-flex gap-2 justify-content-center">
                                  <Button
                                    color="info"
                                    size="sm"
                                    onClick={() => handleView(msg)}
                                  >
                                    عرض
                                  </Button>

                                  <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => handleDelete(msg.id)}
                                  >
                                    حذف
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5">لا توجد رسائل</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="row mt-4">
                    <div className="col text-end">
                      <Pagination
                        currentPage={page}
                        totalPages={totalPages}
                        onPageChange={(newPage) => {
                          setPage(newPage);
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth",
                          });
                        }}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={viewModal} toggle={() => setViewModal(false)} centered>
        <ModalHeader toggle={() => setViewModal(false)}>
          تفاصيل الرسالة
        </ModalHeader>

        <ModalBody>
          {selectedMessage && (
            <>
              <p>
                <strong>الاسم:</strong> {selectedMessage.first_name}{" "}
                {selectedMessage.last_name}
              </p>

              <p>
                <strong>البريد الإلكتروني:</strong> {selectedMessage.email}
              </p>

              <p>
                <strong>رقم الهاتف:</strong> {selectedMessage.phone}
              </p>

              <p>
                <strong>الرسالة:</strong>
                <br />
                {selectedMessage.message}
              </p>

              <p>
                <strong>تاريخ الإرسال:</strong>{" "}
                {new Date(selectedMessage.createdAt).toLocaleString()}
              </p>
            </>
          )}
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={() => setViewModal(false)}>
            غلق
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default ContactUsTable;
